import { MouseEvent } from "react";
import MoreIconVertical from "./images/icons/moreIconVertical.svg?react";
import { IconButton } from "@rg/ui/components/IconButton";

export const MoreButton = (props: {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  id?: string;
}) => {
  return (
    <IconButton
      icon={<MoreIconVertical />}
      onClick={props.onClick}
      aria-label="More button"
      title="Show more options"
      variant="secondary"
      size="sm"
    />
  );
};
